// extracted by mini-css-extract-plugin
export default {"h1":"ReferralLanding_h1__bv+gF","titleContainer":"ReferralLanding_titleContainer__V2Y16"};